import Outline from './Outline';
import SVGParser from './SVGParser';
import PointCurveShape from './PointCurveShape';

export default {
  parse(path: string, xoffset: number = 0, yoffset: number = 0) {
    const outline = new Outline();
    const parser = new SVGParser(outline);
    parser.parse(path, xoffset, yoffset);
    return outline;
  },
  Outline,
  SVGParser,
  PointCurveShape
};